import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', [_c('div', {
    staticClass: "clearfix white-bg"
  }, _vm._l(_vm.districtNames, function (name, index) {
    return _c('div', {
      key: index,
      staticClass: "address-crumb",
      "class": {
        selected: _vm.current == index
      },
      on: {
        "click": function click($event) {
          return _vm.onClickAddressCrumb(index);
        }
      }
    }, [_vm._v(" " + _vm._s(name) + " ")]);
  }), 0), _c('HorizontalSlideContainer', {
    attrs: {
      "current": _vm.current,
      "container-page-count": 5,
      "content-page-count": 3,
      "container-page-index": 2,
      "content-page-offset": 2
    }
  }, [_c('HorizontalSlidePage', [_c('div', {
    staticClass: "district-item-container"
  }, _vm._l(_vm.level1List, function (item) {
    return _c('div', {
      key: item.id,
      staticClass: "district-item after-line",
      "class": {
        selected: item.id == _vm.districtIds[0]
      },
      on: {
        "click": function click($event) {
          return _vm.onClickAddressItem(item.id, 0);
        }
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 0)]), _c('HorizontalSlidePage', [_vm.districtIds[0] != null ? _c('div', {
    staticClass: "district-item-container"
  }, _vm._l(_vm.level2List, function (item) {
    return _c('div', {
      key: item.id,
      staticClass: "district-item after-line",
      "class": {
        selected: item.id == _vm.districtIds[1]
      },
      on: {
        "click": function click($event) {
          return _vm.onClickAddressItem(item.id, 1);
        }
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 0) : _vm._e()]), _c('HorizontalSlidePage', [_vm.districtIds[0] != null ? _c('div', {
    staticClass: "district-item-container"
  }, _vm._l(_vm.level3List, function (item) {
    return _c('div', {
      key: item.id,
      staticClass: "district-item after-line",
      "class": {
        selected: item.id == _vm.districtIds[2]
      },
      on: {
        "click": function click($event) {
          return _vm.onClickAddressItem(item.id, 2);
        }
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 0) : _vm._e()])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };